import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from './composingCorrectionMessages';

const ComposingCorrectionAnswerListActionButton = (props) => {
  return (
    <button onClick={props.onUpload}>
      <div className="card-item-action">
        <i className="ti-upload pending" />
        <FormattedMessage {...messages.upload}>
          {(txt) => <span className="pending">{txt}</span>}
        </FormattedMessage>
      </div>
    </button>
  );
};

ComposingCorrectionAnswerListActionButton.propTypes = {};

export default ComposingCorrectionAnswerListActionButton;
